import css from 'styled-jsx/css';

export default css`
  :global(html) {
    scroll-behavior: smooth !important;
  }
  .product_detail-preview-container {
    background-image: url('/images/landing/lp-b2c-b2b/bg-mobile-retargeting.jpg');
  }
  .product_detail-preview-content {
    padding: 36px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .product_detail-1 {
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    color: var(--grey-dark);
  }
  .product_detail-2 {
    color: #717179;
    text-align: center;
    line-height: 16px;
    font-weight: 300;
    font-size: 16px;
  }
  :global(.content) {
    max-width: none !important;
  }
  :global(.main),
  :global(main) {
    padding: 0px !important;
  }
  :global(main) {
    max-width: 100% !important;
  }
  .product-detail {
    background: var(--background-utils);
    width: 100%;
  }
  .product-detail h1 {
    font-weight: 600;
    font-size: 26px;
  }
  .product-detail__top {
    max-width: 1200px;
    margin: auto;
  }
  .product-detail {
    padding: 0px 0px 20px;
    margin-top: -9px;
  }
  .product-detail :global(.swiper-slide) {
    display: inherit;
    width: 100% !important;
  }
  .product-detail :global(.thumbnails .swiper-slide) {
    max-width: calc(25% - 8px);
    //max-height: 147px;
    cursor: pointer;
  }
  .detail-subcategory-content :global(.swiper-slide),
  .detail-brand-content :global(.swiper-slide) {
    display: inherit;
    max-width: calc(50% - 15px);
    cursor: pointer;
  }
  a {
    cursor: pointer;
  }
  .product-detail::-webkit-scrollbar {
    width: 0.2em;
    position: absolute;
  }
  .product-detail::-webkit-scrollbar-track {
    position: absolute;
  }
  .product-detail::-webkit-scrollbar-thumb {
    position: absolute;
  }
  .product-detail :global(.body) {
    display: block;
  }
  .product-detail :global(.slideshow img) {
    cursor: initial;
  }
  .product-detail :global(.slideshowDots) {
    text-align: center;
  }
  .product-name {
    margin: 16px auto;
  }
  .divider {
    border-bottom: var(--line-header);
  }
  .price-info {
    margin: 16px auto;
  }
  .product-description span {
    font-weight: 600;
  }
  .button-container p {
    font-style: italic;
    margin: 8px 0;
    font-size: 14px;
  }
  .product-description {
    transition: all 0.3s ease;
    font-size: 14px;
    cursor: pointer;
    border-top: 1px solid var(--grey-lighter);
    border-bottom: 1px solid var(--grey-lighter);
  }
  .product-availability {
    margin-top: 16px;
    transition: all 0.3s ease;
    font-size: 14px;
    cursor: pointer;
    border-top: 1px solid var(--grey-lighter);
  }
  .product-description h5,
  .product-availability h5 {
    font-size: 15px;
  }
  .product-description :global(.icon):hover {
    cursor: pointer;
  }
  .product-availability :global(.icon):hover {
    cursor: pointer;
  }
  .head {
    padding: 14px 8px;
  }
  .content {
    padding-top: var(--margin-sm);
    transition: all 0.3s;
  }
  .open {
    border-bottom: none;
  }
  .open .content {
    opacity: 1;
  }
  .close .content {
    opacity: 0;
    max-height: 0px;
    overflow: hidden;
    padding: 0px 8px;
  }
  .availability p {
    font-size: 15px;
    color: var(--accent-dark);
  }
  .availability :global(table) {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }
  .availability :global(table td) {
    border: 1px solid #ddd3;
    text-align: left;
    padding: 8px;
  }
  .availability :global(table tr) {
    text-align: left;
    padding: 8px;
  }
  .availability :global(table tr:nth-child(even)) {
    background-color: #ccc2;
  }
  .availability :global(tbody tr) {
    background: var(--background-utils);
    font-weight: 500;
  }
  @media screen and (max-width: 768px) {
    .fixed-row :global(button.large) {
      font-size: 14px !important;
    }
  }
  @media screen and (max-width: 768px) {
    h3 {
      font-size: 20px;
    }

    .cost h5 {
      font-size: 14px;
    }
    .cost-p h5 {
      font-size: 14px;
    }
    .cost-p p {
      font-size: 22px !important;
      font-weight: 700;
    }
  }
  :global(.turnkey-description) {
    border: solid thin rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background: var(--info-box);
    border-left: solid 10px var(--warning);
    padding: 2px 10px;
  }

  :global(.turnkey-description) p {
    font-size: 13px !important;
    line-height: 20px;
    color: var(--foreground);
  }
  :global(.turnkey-description .icon) {
    color: var(--warning);
  }
  .fixed-row {
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 5;
    right: 0px;
    background: var(--background-utils);
    padding: 1em 20px;
    box-shadow: -2px 0px 5px 1px rgba(0, 0, 0, 0.15);
  }
  .wrapper-dot {
    margin-top: 10px;
  }
  :global(.slider-container ul) {
    display: flex !important;
    gap: 15px;
  }
  :global(.carousel-slide img) {
    border-radius: 10px;
    box-shadow: var(--shadow-light);
    cursor: pointer;
    transition: 0.3s;
  }
  :global(.carousel-slide img):hover {
    box-shadow: var(--shadow-blue);
    transform: translateY(-2px);
  }
  :global(.carousel__dot-group) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }
  :global(.carousel__dot-group button.carousel__dot--selected) {
    background: var(--primary);
  }

  :global(.carousel-button) {
    position: absolute;
    top: 50%;
    transform: translate(-0%, -50%);
    border: solid thin #ccc3;
    background: rgba(255, 255, 255, 0.65);
    color: black;
    border-radius: 2px;
    height: 40px;
  }
  :global(.carousel-button-left) {
    left: -9px;
  }
  :global(.carousel-button-right) {
    right: -9px;
  }
  .info p {
    font-size: 16px;
    font-weight: 500;
    margin: 0px 0px 8px;
  }
  .product-detail :global(.s-container) {
    gap: 5px;
  }
  .product-detail :global(.s-container > div) {
    margin-bottom: 0px;
  }
  .info span {
    font-size: 14px;
    color: var(--accent-dark);
  }
  .product-detail :global(.size-background) {
    border: solid thin var(--blue-marine-lighter);
  }
  .size-input :global(label) {
    display: none;
  }

  :global(.css-1s2u09g-control),
  :global(.css-1pahdxg-control) {
    border-radius: 50px;
    height: 50px;
  }
  .product-detail :global(.size-background) {
    background: var(--social-button);
    border-radius: 0;
    height: 40px;
    width: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cart-message {
    border: solid thin rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 0px;
    margin: 0px 0px 8px;
  }
  .cart-message-container {
    width: calc(65% + 30px);
    display: flex;
  }
  .cart-icon-container {
    background-color: var(--info);
    height: auto;
    align-items: center;
    display: flex;
    padding: 14px 6px;
    border-radius: 6px 0 0 6px;
  }
  .cart-text {
    padding: 0px 8px;
    font-size: 15px;
  }
  .cost-p p {
    font-size: 24px;
    font-weight: 700;
  }
  .shipping-cost a {
    color: var(--primary);
  }
  .shipping-cost p :global(.icon) {
    font-size: 22px;
  }
  .shipping-cost p {
    font-size: 14px;
  }
  .product-detail :global(.input-drop input),
  .product-detail :global(.input-drop) {
    height: 50px;
  }
  .product-detail :global(.icon-input) {
    top: 15px;
  }
  .product-detail :global(button.outlined) {
    border: 2px solid var(--primary-button);
  }
  .product-detail :global(.drop-list) {
    background: var(--background-utils);
    border: solid thin grey;
  }
  .product-detail :global(.drop-list li) {
    background: var(--background-utils);
  }
  .product-detail :global(.drop-list li:nth-child(even)) {
    background-color: #ccc2;
  }
  .dropdown-mobile label {
    font-size: 15px;
    font-weight: 600;
  }
  .alert-delay {
    color: var(--grey-lighter);
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
  }
  .ellipsis-modal {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 215px;
  }
  .availability .out-of-stock {
    font-size: 14px;
    background: var(--foreground);
    margin-top: 4px;
    color: var(--sort-background);
    font-weight: 400;
    padding: 0em 0.3em;
    opacity: 1 !important;
    margin-bottom: 4px;
  }
  .iva-escl {
    font-size: 15px;
    font-weight: 400;
    opacity: 0.6;
  }
  .l-t {
    text-decoration-line: line-through;
    font-weight: 300;
    font-size: 16px;
    text-decoration-style: solid;
    text-decoration-color: var(--disabled);
  }
  :global(.slider-image > div) {
    padding-bottom: 100% !important;
  }
  :global(.thumbnails .swiper-slide) {
    border: 1px solid #f1f1f1;
  }
  :global(.thumbnails .swiper-slide-thumb-active) {
    border: 1px solid var(--black);
  }
  :global(.thumbnails .swiper-slide) {
    cursor: pointer;
  }
  :global(.swiper-wrapper) {
    margin-top: 10px !important;
    height: 100%;
  }
  :global(.swiper-autoheight .swiper-wrapper) {
    min-height: 586px;
    margin-top: 10px !important;
  }
  @media screen and (max-width: 490px) {
    :global(.swiper-autoheight .swiper-wrapper) {
      min-height: 341px;
      margin-top: 10px !important;
    }
  }
  :global(.swiper-detail .swiper-slide) {
    border: 1px solid #f1f1f1;
  }
  .detail-shipping {
    margin: 5px 0;
    font-size: 16px;
    font-weight: 500;
  }
  :global(.swiper-subcategory .swiper-grab-container),
  :global(.swiper-review) {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    gap: 5px;
  }
  :global(.swiper-review) {
    background: white;
    border-radius: 8px;
    padding: 1em;
  }
  .review-title {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .review {
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
  }
  .related-description {
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    text-align: center;
    line-height: normal;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .related-brand {
    font-size: 10px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    text-transform: uppercase;
  }
  .related-taxable {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
  }
  .view-all-link {
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
    text-align: center;
    color: var(--primary);
    display: flex;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
  }
  .detail-brand {
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .detail-brand span {
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
  }
  .detail-retail-price {
    color: var(--disabled);
  }
  .detail-model-label {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .detail-background_2 {
    background-color: #f9f8fd;
    margin: 15px 0px;
  }
  .detail-background {
    background-color: var(--background);
    margin: 15px 0px;
  }
  .detail-background-padding {
    padding: 2em 0em !important;
  }
  .reviews-background-padding {
    padding: 2em 0em 0em !important;
  }
  .detail-subcategory-content,
  .swiper-content {
    max-width: 1200px;
    margin: auto;
  }
  .detail-brand-content {
    max-width: 1200px;
    margin: auto;
  }
  .tag-content {
    border: solid thin #92a0ae;
    padding: 0.5em;
    border-radius: var(--radius);
    flex-wrap: wrap;
  }
  .save {
    color: var(--primary);
  }
  .padding-text {
    padding: 0em;
  }

  @media screen and (max-width: 1240px) {
    .detail-shipping {
      margin-top: 5px;
      margin-bottom: 20px;
    }
  }
  .padding-md {
    padding: 0em;
  }

  .share-box,
  .payment-method {
    background: #f0f8fe;
    padding: 1em;
    margin: 1em 0em;
    border-radius: 8px;
  }

  .section-document {
    margin: 8px 0px 16px;
    padding: 1.2em;
    border-radius: 6px;
    position: relative;
    background: var(--background);
    border: solid thin #ccc;
  }

  .padding-breadcrumb {
    padding: 1em 0em;
  }
  @media screen and (max-width: 768px) {
    .product-detail__top {
      padding: 0;
    }
    .padding-breadcrumb {
      padding: 1em 1em 0em;
    }
    .padding-md {
      padding: 0em 1em;
    }
    :global(.swiper-detail) {
      padding: 0em 1em 0em;
    }
    .padding-text {
      padding: 0em 1em 0em;
    }
    .share-box,
    .payment-method {
      background: #f0f8fe;
      padding: 1em;
      margin: 1em;
      border-radius: 8px;
    }
    .section-document {
      margin: 8px 16px 16px;
      padding: 1.2em;
      border-radius: 6px;
      position: relative;
      background: var(--background);
      border: solid thin #ccc;
    }
  }
  .cashback {
    padding: 0.3em 0.6em;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    background: #60f3d754;
    border: solid thin #60f3d7;
  }
  .black-friday {
    padding: 0.3em 0.6em;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    background: linear-gradient(90deg, #e1fe0099, #e1fe0099);
  }

  .cashback-amount {
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .related-cashback {
    padding: 0em;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    background: none;
    color: #fd8d09 !important;
  }
  .related-cashback-amount {
    color: #fd8d09;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .section-cashback {
    margin: 8px 0px 16px;
    padding: 1.2em;
    border-radius: 6px;
    position: relative;
    background: #f9d17b29;
    border: solid thin #feda8b;
  }

  .section-cashback:before {
    content: ' ';
    display: block;
    position: absolute;
    border-radius: 6px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.12;
    border: solid thin black;
    background-image: url(/images/home/new/bg_prefooter.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  :global(.promo-cost) {
    background: #e1fe00;
    padding: 2px 4px;
    color: black;
    box-shadow: var(--shadow-light);
  }
  :global(.flag-discount p) {
    font-size: 11px !important;
    font-weight: 500 !important;
    line-height: 14px;
    color: black !important;
    text-align: center;
  }
  :global(.flag-discount) {
    color: black;
    display: block;
    border-radius: 4px;
    float: left;
    padding: 5px 4px;
    background: linear-gradient(90deg, #e1fe00, #e1fe00);
    font-weight: 400;
    width: 60px;
    position: absolute;
    right: 16px;
    z-index: 1;
    top: 10px;
  }
  .video-player {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: inline-block;
  }
  .video-player-thumb {
    width: 100%;
    object-fit: contain;
    display: inline-block;
  }
  .video-player-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  .icon-play-btn {
    position: absolute;
    top: 50%;
    right: 50%;
    width: 45px;
    height: 45px;
    border-radius: 100px;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%);
    border: solid thin #fff5;
  }
  .icon-play-btn :global(.icon) {
    font-size: 24px;
    margin-left: 5px;
    color: white;
  }

  .product-detail :global(.swiper-horizontal > .swiper-pagination-progressbar),
  .product-detail
    :global(.swiper-pagination-progressbar.swiper-pagination-horizontal),
  .product-detail
    :global(.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite),
  .product-detail
    :global(.swiper-vertical
      > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite),
  .product-detail
    :global(.swiper-horizontal
      > .swiper-pagination-progressbar, .swiper-pagination-progressbar.swiper-pagination-horizontal) {
    width: 100%;
    height: 2px;
    left: 0;
    bottom: 0px;
    top: inherit;
  }
  :global(.thumbnails) {
    padding-bottom: 20px;
  }
  :global(.content_read_more) {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  :global(.content_read_more_ios) {
    overflow: hidden;
    position: relative;
    line-height: 1.5rem;
    max-height: 7.5rem;
    text-align: justify;
  }
  .content_read_more_ios:before {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .content_read_more_ios:after {
    content: '';
    position: absolute;
    right: 0;
    width: 1rem;
    height: 1rem;
    margin-top: 0.2rem;
    background: white;
  }

  .content_read_more :global(span),
  .content_read_more :global(p),
  .content_read_more_ios :global(span),
  .content_read_more_ios :global(p),
  .content_default :global(span),
  .content_default :global(p) {
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 400 !important;
    line-height: normal !important;
  }
  .content_read_more :global(strong) {
  }
  .read-more-span span,
  .read-less-span span {
    color: var(--blu-cta, #3f9df4);
    text-align: center;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration-line: underline;
    cursor: pointer;
  }

  .detail-wrapper {
    padding: 1em 0;
  }
  .info-wrapper {
    padding: 1em;
  }
  .trustpilot-background {
    padding: 2em;
  }
  .read-more-span {
    color: var(--blu-cta, #3f9df4);
    background: var(--background-utils);
    width: 100%;
    padding: 10px;
    z-index: 2;
    position: relative;
  }
  .read-less-span {
    color: var(--blu-cta, #3f9df4);
    background: var(--background-utils);
    margin-top: 0px !important;
    width: 100%;
    padding: 10px;
    box-shadow: none;
    z-index: 2;
    position: relative;
  }
  .li-detail span {
    font-size: 12px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    color: var(--scuro-x-testi, #2a2c41);
  }
  .li-detail p {
    font-size: 14px;
    font-style: normal;
    color: var(--scuro-x-testi, #2a2c41);
    font-weight: 500;
    line-height: normal;
  }

  .payment-margin {
    margin: 3em 1em;
  }
  .share-span {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: var(--grey-dark);
  }
  .share-title {
    color: var(--blu-cta, #3f9df4);
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .share-cta {
    color: var(--blu-cta, #3f9df4);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-decoration-line: underline;
  }
  .share-circle {
    width: 50px;
    position: absolute;
    height: 50px;
    background: #3f9df4;
    border-radius: 100px;
    right: 16px;
    bottom: -22px;
  }
  .margin-accordion {
    margin: 40px 0px;
  }
  .detail :global(.accordion-container) {
    border-bottom: var(--line);
    padding: 16px;
    margin-top: 0;
  }
  .detail :global(.accordion-text) {
    font-size: 16px;
    margin: 0;
    font-weight: 600;
    text-align: left;
    color: var(--foreground);
  }
  .detail :global(.accordion-icon) {
    font-size: 22px;
    font-weight: 600;
    right: 16px;
    color: var(--foreground);
  }
  .detail__accordion {
    gap: 10px;
    padding: 14px;
    display: flex;
    flex-direction: column;
    border-left: solid 2px var(--primary);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .bg-reviews {
    background: var(--arancione-chiaro, #fad8b4) !important;
  }
  :global(.swiper-reviews) {
    padding-bottom: 55px;
  }
  :global(button.radius-xl) {
    border-radius: 50px !important;
  }
  .rating :global(svg) {
    color: var(--primary);
    font-size: 25px;
  }
  .bold {
    font-weight: 600;
  }
  .block-title {
    color: var(--scuro-x-testi, #2a2c41);
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  .block-desc {
    color: var(--scuro-x-testi, #2a2c41);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .block-subTitle {
    color: var(--arancione, --primary);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
  }
  :global(.vat-it) p {
    font-size: 15px;
    line-height: 20px;
    color: var(--foreground);
  }

  :global(.vat-it .icon) {
    color: var(--info);
  }
  :global(.vat-it-info) {
    background: var(--info-box);
    padding: 1.5em 1em 1em;
    border-radius: 10px;
  }
  @media screen and (max-width: 768px) {
    .detail-wrapper {
      padding: 1em;
    }
    .cashback-wrapper {
      padding: 0 1em;
    }
    .product-detail :global(.thumbnails .swiper-slide) {
      max-width: calc(25% - 8px);
      //max-height: 150px;
      cursor: pointer;
    }
    .detail-subcategory-content :global(.swiper-slide),
    .detail-brand-content :global(.swiper-slide) {
      max-width: calc(50%);
      margin: 0px 6px;
    }
    .swiper-content :global(.swiper-slide) {
      max-width: calc(65%);
      margin: 0px 6px;
    }
    .detail-subcategory-content :global(.swiper-slide:first-child),
    .detail-brand-content :global(.swiper-slide:first-child),
    .swiper-content :global(.swiper-slide:first-child),
    :global(.thumbnails .swiper-slide:first-child) {
      margin-left: 1em !important;
    }
    .detail-subcategory-content :global(.swiper-slide:last-child),
    .detail-brand-content :global(.swiper-slide:last-child),
    .swiper-content :global(.swiper-slide:last-child),
    :global(.thumbnails .swiper-slide:last-child) {
      margin-right: 1em !important;
    }
  }
  @media screen and (min-width: 768px) {
    .product-detail :global(.body) {
      display: flex;
    }

    .product-availability {
      margin-top: 0px;
      transition: all 0.3s ease;
      font-size: 14px;
    }
    .product-description {
      transition: all 0.3s ease;
      font-size: 14px;
    }
    .product-detail-sticky {
      position: sticky;
      align-self: flex-start;
      top: 110px;
    }
    .detail-brand-content :global(.swiper-slide),
    .detail-subcategory-content :global(.swiper-slide) {
      display: inherit;
      max-width: calc(24% - 15px);
    }
    .swiper-content :global(.swiper-slide) {
      display: inherit;
      max-width: calc(33% - 15px);
    }
  }
`;
